export function setSEO({ title, description, canonical }) {
  document.title = title ? `${title} | MS Discoveries` : 'MS Discoveries – Smart Business Growth Platform';
  const desc = document.querySelector('meta[name="description"]');
  if (desc && description) desc.setAttribute('content', description);
  if (canonical) {
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) { link = document.createElement('link'); link.rel = 'canonical'; document.head.appendChild(link); }
    link.href = `https://msdiscoveries.com${canonical}`;
  }
}